const datas = {
    question1: {
        title1: {
            text: "Avez-vous",
            class: "d-flex large-font large-text"
        },
        title2: {
            text: "connaissance",
            class: "d-flex large-font p-tag p-tag-rounded large-text-tag"
        },
        title3: {
            text: "de",
            class: "d-flex large-font large-text"
        },
        title4: {
            text: "l’offre Green IT",
            class: "d-flex large-font p-tag p-tag-rounded large-text-tag "
        },
        title5: {
            text: "du Groupe Créative ?",
            class: "d-flex large-font large-text"
        },
        image: "img-question-1.png",
        url: "/campagne"
    },
    question2: {
        title1: {
            text: "Voulez-vous adopter",
            class: "d-flex large-font large-text"
        },
        title2: {
            text: "une stratégie",
            class: "d-flex large-font large-text"
        },
        title3: {
            text: "d’éco-conception",
            class: "d-flex large-font p-tag p-tag-rounded large-text-tag "
        },
        title4: {
            text: "dès",
            class: "d-flex large-font large-text"
        },
        title5: {
            text: "votre",
            class: "d-flex large-font large-text"
        },
        title6: {
            text: "prochain projet ?",
            class: "d-flex large-font p-tag p-tag-rounded large-text-tag"
        },
        image: "img-question-2.png",
        url: "/formulaire"
    }
}

export default datas;